import type { MouseEvent } from 'react'
import { Button } from '@highlight/ui'
import { ChevronDown, ChevronUp } from 'lucide-react'

interface ReportExpandToggleProps {
  isExpanded: boolean
  onToggle: () => void
  className?: string
}

/**
 * Lifts the height cap on a report or action card so the whole body can be read
 * in place (TRU-51). Stops propagation because the cards it sits in open or
 * focus the action on click.
 */
export function ReportExpandToggle({ isExpanded, onToggle, className }: ReportExpandToggleProps) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    onToggle()
  }

  return (
    <Button
      size="xs"
      variant="ghost"
      aria-expanded={isExpanded}
      left={isExpanded ? <ChevronUp /> : <ChevronDown />}
      onClick={handleClick}
      className={className}
    >
      {isExpanded ? 'Show less' : 'Show more'}
    </Button>
  )
}
